import { render, staticRenderFns } from "./SearchTable.vue?vue&type=template&id=864b6aac"
import script from "./SearchTable.vue?vue&type=script&lang=js"
export * from "./SearchTable.vue?vue&type=script&lang=js"
import style0 from "./SearchTable.vue?vue&type=style&index=0&id=864b6aac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports